import { can } from '@clim/client-core';
import { NavLink, Outlet } from 'react-router-dom';
import { Empty } from '../../components/ui';
import { useReady } from '../../lib/session';
import { useOnline } from '../../lib/use-online';

export function AdminLayout() {
  const { me } = useReady();
  const online = useOnline();
  return (
    <section>
      <h1>Administration</h1>
      <nav className="subtabs">
        {can(me, 'catalog.manage') && <NavLink to="catalogue">Catalogue & prix</NavLink>}
        {can(me, 'user.read') && <NavLink to="utilisateurs">Équipe</NavLink>}
        {can(me, 'role.read') && <NavLink to="roles">Rôles & permissions</NavLink>}
        {can(me, 'territory.manage') && <NavLink to="territoires">Territoires</NavLink>}
        {can(me, 'referential.manage') && <NavLink to="referentiels">Référentiels</NavLink>}
        {can(me, 'audit.read') && <NavLink to="audit">Journal d’audit</NavLink>}
        {can(me, 'legal_text.manage') && <NavLink to="textes">Textes juridiques</NavLink>}
        {can(me, 'commission.rules.manage') && <NavLink to="equipes">Chefs d’équipe</NavLink>}
        {can(me, 'payment_method.manage') && <NavLink to="paiements">Moyens de paiement</NavLink>}
        {can(me, 'tenant.settings.manage') && <NavLink to="parametres">Entreprise</NavLink>}
        {can(me, 'tenant.settings.manage') && <NavLink to="notifications">Notifications</NavLink>}
        {can(me, 'tenant.settings.manage') && <NavLink to="envois">E-mails & SMS</NavLink>}
      </nav>
      {online ? <Outlet /> : <Empty>L’administration nécessite une connexion.</Empty>}
    </section>
  );
}
